import React from 'react';
import ReactDOM from 'react-dom';

import ServicesList from './react-components/services-list'
import Section from './react-components/section';
import TestimonialsList from './react-components/testimonials-list';
import FaqList from './react-components/faq-list'
import OffersList from './react-components/offers-list'
import EmployeesList from './react-components/employees-list';

//WPML notice: we need to pass lang param due to caching

if( document.getElementById('services') !== null) {
    ReactDOM.render(
        <Section api_url={wp_core.base_url + '/wp-json/home/services?lang=' + wp_core.icl_language_code}>
            <ServicesList />
        </Section>, document.getElementById('services')
      );
}

if( document.getElementById('testimonials') !== null) {
    ReactDOM.render(
        <Section api_url={wp_core.base_url + '/wp-json/wp/v2/testimonial?lang=' + wp_core.icl_language_code + '&per_page=2'}>
            <TestimonialsList />
        </Section>, document.getElementById('testimonials')
      );
}

if( document.getElementById('faq') !== null) {
    ReactDOM.render(
        <Section api_url={wp_core.base_url + '/wp-json/wp/v2/faq?lang=' + wp_core.icl_language_code + '&per_page=6&orderby=menu_order&order=asc'}>
            <FaqList />
        </Section>, document.getElementById('faq')
      );
}

if( document.getElementById('offers') !== null) {
    ReactDOM.render(
        <Section api_url={wp_core.base_url + '/wp-json/home/offers?lang=' + wp_core.icl_language_code}>
            <OffersList />
        </Section>, document.getElementById('offers')
      );
}

if( document.getElementById('team') !== null) {
    ReactDOM.render(
        <Section api_url={wp_core.base_url + '/wp-json/wp/v2/employee?lang=' + wp_core.icl_language_code + '&per_page=20'}>
            <EmployeesList />
        </Section>, document.getElementById('team')
      );
}